// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { SettingOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { SettingOutlined };

// ==============================|| MENU ITEMS - SETTINGS ||============================== //

const settings: NavItemType = {
  id: 'settings',
  title: <FormattedMessage id="settings-menu-item" />,
  type: 'group',
  url: '/settings',
  icon: icons.SettingOutlined
};

export default settings;
